import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { NameVoteData, NewNamesVotersInfo } from '../+models';
import { withStorageSync } from './storege-sync.feature';
import { environment } from '../../../environments/environment';
import { AppState } from 'src/app/types/app-state';

const initialState: AppState = {
  project: '',
  name: '',
  nameVoteData: [],
  newNamesVotersInfo: [],
};

export const NAME_VOTE_STORE = signalStore(
  { providedIn: 'root', protectedState: false },
  withState(initialState),
  withStorageSync({
    key: environment.providers.nameVotesStore.toLowerCase(),
  }),
  withMethods((store) => ({
    clearStore() {
      patchState(store, initialState);
      store.clearStorage();
    },
    updateProject(project: string) {
      patchState(store, { project });
    },
    updateName(name: string) {
      patchState(store, { name });
    },
    updatenameVoteData(newnameVoteData: NameVoteData) {
      const currentState = store.nameVoteData() ?? [];

      // Check if the name already exists
      const existingIndex = currentState.findIndex(
        (item) => item.name === newnameVoteData.name
      );

      if (existingIndex >= 0) {
        // If the name already exists, update the existing data with the new data
        const updatedArray = [...currentState];
        updatedArray[existingIndex] = {
          ...updatedArray[existingIndex],
          vote: newnameVoteData.vote,
        };
        patchState(store, {
          nameVoteData: updatedArray,
        });
      } else {
        // If the name does not exist, add the new data
        patchState(store, {
          nameVoteData: [...currentState, newnameVoteData],
        });
      }
    },
    addNewNamesVoters(newNamesVotersInfo: NewNamesVotersInfo) {
      const currentState = store.newNamesVotersInfo() ?? [];

      // Check if the email already exists
      const existingIndex = currentState.findIndex(
        (item) => item.email === newNamesVotersInfo.email
      );

      if (existingIndex >= 0) {
        // If the email already exists, update the existing data with the new data
        const updatedArray = [...currentState];
        updatedArray[existingIndex] = {
          ...updatedArray[existingIndex],
          newNames: [
            ...new Set([
              ...updatedArray[existingIndex].newNames,
              ...newNamesVotersInfo.newNames,
            ]),
          ],
        };
        patchState(store, {
          newNamesVotersInfo: updatedArray,
        });
      } else {
        // If the email does not exist, add the new data
        patchState(store, {
          newNamesVotersInfo: [...currentState, newNamesVotersInfo],
        });
      }
    },
    clearNewNamesVotersInfo() {
      const username = localStorage.getItem('username');
      const currentState = store.newNamesVotersInfo() ?? [];
      const updatedArray = currentState.filter(
        (item) => item.email !== username
      );
      patchState(store, { newNamesVotersInfo: updatedArray });
    },

    updateNewNamesVoters(newEntries: NewNamesVotersInfo[]) {
      patchState(store, { newNamesVotersInfo: newEntries });
    },
  }))
);
